module.exports = __webpack_public_path__ + "static/media/cq_freccia_su.f154a734.svg";